import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './components/home/Home';
import { ServiceLocations } from './components/ServiceLocations/ServiceLocations';
import { About } from './components/about/About';
import { Services } from './components/services/Services';
import { Quote } from './components/quote/Quote';
import { Contact } from './components/contact/Contact';
import { Gallery } from './components/gallery/Gallery';
import { Footer } from './components/footer/Footer';
import { Navbar } from './components/navbar/Navbar';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/service-locations" element={<ServiceLocations />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/quote" element={<Quote />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gallery" element={<Gallery />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;


// function App(){
//   return(
//     <div>
//       <h1>Warning⚠️: service has been suspended due to incompleted payments.</h1>
//       <p style={{color:"red"}}>site will be parmanently blocked.</p>
//     </div>
//   )
// }
// export default App;